import { useModules } from '../../lib/useModules';

/**
 * Bloquea una ruta cuyo módulo (o función) está deshabilitado para el tenant.
 *
 * Se muestra un cartel en lugar de redirigir en silencio: si alguien llega por
 * un enlace guardado o un marcador, entiende qué pasó en vez de ver una
 * pantalla en blanco o un rebote inexplicable.
 *
 * Uso:
 *   <ModuleGuard module="deals"><DealsBoard /></ModuleGuard>
 *   <ModuleGuard module="leads" feature="archived"><ArchivedLeads /></ModuleGuard>
 */
export default function ModuleGuard({ module, feature = null, children }) {
    const { isModuleEnabled, isFeatureEnabled } = useModules();

    const allowed = feature
        ? isFeatureEnabled(module, feature)
        : isModuleEnabled(module);

    if (allowed) return children;

    return (
        <div className="flex-1 flex flex-col items-center justify-center p-8 text-center">
            <div className="size-16 rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center mb-5">
                <span className="material-symbols-outlined text-3xl text-slate-400">lock</span>
            </div>
            <h2 className="text-lg font-bold text-slate-800 dark:text-slate-100 mb-1.5">
                Módulo no disponible
            </h2>
            <p className="text-sm text-slate-500 dark:text-slate-400 max-w-sm">
                Esta sección no está habilitada para tu cuenta. Si necesitás acceso,
                contactá al administrador de la plataforma.
            </p>
        </div>
    );
}
